<template>
  <div class="min-h-screen bg-gray-50">
    <div class="container mx-auto p-2 sm:p-6">
      <div class="flex justify-center items-center h-[calc(100vh-360px)]">
        <div class="w-full max-w-md px-4">
          <div class="bg-white py-6 sm:py-8 px-4 sm:px-10 shadow sm:rounded-lg border border-gray-200">
            <h2 class="text-center text-xl sm:text-2xl font-bold text-gray-900 mb-2">
              중간관리자 세금계산서
            </h2>
            <p class="text-center text-xs sm:text-sm text-gray-600 mb-4 sm:mb-6">
              세금계산서 확인을 위한 로그인 페이지입니다
            </p>

            <form class="space-y-4 sm:space-y-6 mt-5" @submit.prevent="handleLogin">
              <div>
                <label for="busNo" class="block text-xs sm:text-sm font-medium text-gray-700">
                  사업자번호
                </label>
                <div class="mt-1 relative rounded-md shadow-sm">
                  <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                    <UserIcon class="h-4 w-4 sm:h-5 sm:w-5 text-gray-400" />
                  </div>
                  <input id="busNo" name="busNo" type="text" required v-model="bus_no"
                    :class="{ 'border-red-300': errors.busNo }"
                    class="appearance-none block w-full pl-8 sm:pl-10 px-3 py-2 text-sm border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                    placeholder="사업자번호를 입력해주세요" />
                </div>
                <p v-if="errors.busNo" class="mt-1 text-xs text-red-600">{{ errors.busNo }}</p>
              </div>

              <div>
                <button type="submit" :disabled="isLoading"
                  class="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500">
                  <LoaderIcon v-if="isLoading" class="animate-spin -ml-1 mr-3 h-4 w-4 sm:h-5 sm:w-5 text-white" />
                  <span v-if="isLoading">확인 중...</span>
                  <span v-else>확인</span>
                </button>
              </div>
            </form>

            <div class="mt-4 sm:mt-6">
              <p class="mt-5 sm:mt-3 text-xs text-center text-red-500">
                *문서 확인을 위해서는 국세청 방침에 따라 보안절차를 거치셔야 합니다.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, reactive } from 'vue'
import { UserIcon, LoaderIcon } from 'lucide-vue-next'
import { useRouter } from 'vue-router'
import taxAPI from '@/api/tax/tax'
import Swal from 'sweetalert2'

const router = useRouter()
const bus_no = ref('')
const isLoading = ref(false)
const errors = reactive({
  busNo: ''
})

const validateForm = () => {
  let isValid = true
  errors.busNo = ''

  if (!bus_no.value) {
    errors.busNo = '사업자번호를 입력해주세요.'
    isValid = false
  }

  return isValid
}

const handleLogin = async () => {
  if (!validateForm()) return

  isLoading.value = true
  errors.busNo = ''

  try {
    console.log('로그인 시도 - 입력된 bus_no:', bus_no.value)
    console.log('로그인 API 호출 전:', {
      bus_no: bus_no.value,
      type: typeof bus_no.value,
      length: bus_no.value?.length
    })
    
    const response = await taxAPI.login(bus_no.value)
    
    if (response == 1) {
      console.log('로그인 성공, 페이지 이동:', {
        bus_no: bus_no.value,
        route: {
          name: 'tax_view',
          params: { bus_no: bus_no.value }
        }
      })
      router.push({ 
        name: 'tax_view', 
        params: { bus_no: bus_no.value }
      })
    } else {
      await Swal.fire({
        icon: 'error',
        title: '세금계산서 발행 매장이 아닙니다',
        text: '담당에게 문의 하시기 바랍니다'
      })
    }
  } catch (error) {
    console.error('로그인 에러:', error)
    await Swal.fire({
      icon: 'error',
      title: '로그인 오류',
      text: '서버와의 통신 중 오류가 발생했습니다.'
    })
  } finally {
    isLoading.value = false
  }
}
</script>
